export enum ConditionType {
    Question = 'question',
}

export enum ConditionOperator {
    Or = 'or',
    And = 'and',
}

export enum ComparisonOperator {
    Eq = 'eq',
    Neq = 'neq',
}
